import { render, staticRenderFns } from "./SlideFormDetail.vue?vue&type=template&id=0319aa4b&scoped=true&"
import script from "./SlideFormDetail.vue?vue&type=script&lang=js&"
export * from "./SlideFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./SlideFormDetail.vue?vue&type=style&index=0&id=0319aa4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319aa4b",
  null
  
)

export default component.exports